<template>
  <div>
    <div class="box" style="margin-top: -24px; padding: 10px">
      <div class="columns is-multiline">
        <div class="column is-2">
          <div class="control">
            <label class="label">ເລກທີບິນ:</label>
            <input class="input" placeholder="ຄົ້ນຫາຂໍ້ມູນ..." v-model="shipment_number"
                   @keyup.enter="FilterShipmentNumber()">
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="startDate"
                :disabled-date="disabledAfterToday"
                v-validate="'required'"
                :clearable="false"
                name="valid_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="endDate"
                :disabled-date="disabledAfterToday"
                v-validate="'required'"
                :clearable="false"
                name="valid_date"
            ></date-picker>
          </div>
        </div>

        <div class="column is-2" v-if="$can('accountingmanager')">
          <div class="control">
            <label class="label">ປະເພດສາຂາຕົ້ນທາງ:</label>
            <div class="select">
              <select class="input" v-model="selectedBranchType">
                <option value="branch">ສາຂາຫຼັກທັງໝົດ</option>
                <option value="branch_capital">ສາຂາຫຼັກນະຄອນຫຼວງ</option>
                <option value="branch_province">ສາຂາຫຼັກຕ່າງແຂວງ</option>
                <option value="franchise">ສາຂາແຟນຊາຍ</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2" v-if="$can('accountingoriginbranch')">
          <div class="control">
            <label class="label">ປະເພດສາຂາຕົ້ນທາງ:</label>
            <div class="select">
              <select class="input" v-model="selectedBranchType">
                <option value="branch">ສາຂາຫຼັກທັງໝົດ</option>
                <option value="branch_capital">ສາຂາຫຼັກນະຄອນຫຼວງ</option>
                <option value="branch_province">ສາຂາຫຼັກຕ່າງແຂວງ</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2" v-if="$can('accountingoriginfranchise')">
          <div class="control">
            <label class="label">ປະເພດສາຂາຕົ້ນທາງ:</label>
            <div class="select">
              <select class="input" v-model="selectedBranchType">
                <option value="franchise">ສາຂາແຟນຊາຍ</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ສາຂາຕົ້ນທາງ:</label>
            <model-list-select
                :list="listBranches"
                v-model="selectedBranch"
                placeholder="ເລືອກສາຂາຕົ້ນທາງ"
                option-text="name"
                option-value="id"
                selectedItem="name"
            >
            </model-list-select>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ສະຖານະອິນວອຍ:</label>
            <div class="select">
              <select class="input" v-model="selectedStatus.value" @change="FilterStatus()">
                <option v-for="(item, index) in status" :key="index" :value="item.value">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12" :style="{textAlign: 'center'}">
          <button
              class="button btn-export-split"
              :style="{marginLeft: '10px'}"
              @click="OpenModalPrintInvoiceCOD_Split()"
              :disabled="!isSelectingOrders"
          >
            export - {{ actualSelectedItems.length }} ( ເເຍກ )
          </button>
          <button
              class="button btn-export-sum"
              :style="{marginLeft: '10px'}"
              @click="ExportExcel_By_Sum()"
              :disabled="!isSelectingOrders"
          >
            Export - {{ actualSelectedItems.length }} ( ລວມ )
          </button>
        </div>
      </div>
      <hr :style="{marginTop: '-10px'}">
      <div class="center" :style="{marginTop: '-10px'}">
        <vs-table>
          <template #thead>
            <vs-tr>
              <vs-th>ລວມເປັນເງິນທັງໝົດ</vs-th>
              <vs-th>ລວມເງິນລູກຄ້າລາຍເດືອນ</vs-th>
              <vs-th>ລວມລາຍໄດ້ສາຂາ</vs-th>
              <vs-th>ລວມ</vs-th>
              <vs-th>ລວມບິນ</vs-th>
            </vs-tr>
          </template>
          <template #tbody>
            <vs-tr :is-selected="true">
              <vs-td>
                <span v-if="summary.total === 0">0 ກີບ</span>
                <span v-else>{{ FormatPrice(summary.total) }}</span>
              </vs-td>
              <vs-td>
                <span v-if="summary.total_monthly_company === 0">0 ກີບ</span>
                <span v-else>{{ FormatPrice(summary.total_monthly_company) }}</span>
              </vs-td>
              <vs-td>
                <span v-if="summary.total_branch === 0">0 ກີບ</span>
                <span v-else>{{ FormatPrice(summary.total_branch) }}</span>
              </vs-td>
              <vs-td>{{ count }} ສາຂາ</vs-td>
              <vs-td>
                <span v-if="summary.shipment_amount === 0">0 ບິນ</span>
                <span v-else>{{ FormatBillNumber(summary.shipment_amount) }}</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <div class="center table-limit-height" style="margin-top: -15px;">
      <vs-table v-model="pageInvoices" ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>
              <div class="center">
                <vs-checkbox danger
                             @click="onCheckAllCheckBoxChanged"
                             :value="isIndeterminate || isSelectAllOrders"
                             :loading="isSelecting"
                             :checked-force="isSelectAllOrders"
                             :indeterminate="isIndeterminate">
                  <span :style="{fontSize: '16px', marginLeft: '8px'}">ທັງໝົດ</span>
                </vs-checkbox>
              </div>
            </vs-th>
            <vs-th>ວັນທີສ້າງ</vs-th>
            <vs-th>ວັນທີສຳເລັດ</vs-th>
            <vs-th>ເລກອິນວອຍ</vs-th>
            <vs-th>ຊື່ສາຂາ</vs-th>
            <vs-th>ລູກຄ້າລາຍເດືອນ</vs-th>
            <vs-th>ລາຍໄດ້ສາຂາ</vs-th>
            <vs-th>ຈຳນວນເງິນທັງໝົດ</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th>ຫຼັກຖານການໂອນເງິນ</vs-th>
            <vs-th>ໝາຍເຫດ</vs-th>
            <vs-th></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              v-for="(item, index) in invoices"
              :is-selected="isRowSelected(item.id)"
              :data="item"
              @selected="onItemCheckBoxChanged(item)">
            <vs-td>
              <div class="center con-checkbox">
                <vs-checkbox danger
                             :checked-force="isRowSelected(item.id)"
                             :val="item" @click="onItemCheckBoxChanged(item)">
                  <span :style="{fontSize: '16px', marginLeft: '10px'}">{{ index + 1 }}</span>
                </vs-checkbox>
              </div>
            </vs-td>
            <vs-td>{{ FormatDate(item.created_at) }}</vs-td>
            <vs-td v-if="item.invoice_success_at">{{ FormatDate(item.invoice_success_at) }}</vs-td>
            <vs-td v-else></vs-td>
            <vs-td>{{ item.invoice_id }}</vs-td>
            <vs-td>{{ item.branch_name }}</vs-td>
            <vs-td>
              <span v-if="item.monthly_company == 0">0 ກີບ</span>
              <span v-else>{{ FormatPrice(item.monthly_company) }}</span>
            </vs-td>
            <vs-td>
              <span v-if="item.branch == 0">0 ກີບ</span>
              <span v-else>{{ FormatPrice(item.branch) }}</span>
            </vs-td>
            <vs-td>{{ FormatPrice(item.branch + item.monthly_company) }}</vs-td>
            <vs-td>{{ la_status[item.invoice_status] }}</vs-td>
            <vs-td>
              <div v-if="item.payment_img" class="img-size">
                <expandable-image class="image" :src=item.payment_img></expandable-image>
              </div>
            </vs-td>
            <vs-td>{{ item.invoice_remark }}</vs-td>
            <vs-td>
              <div class="group-icon">
                <vs-button circle icon flat
                           @click="EditStatementOrigin(item)"
                >
                  <i class="fad fa-pencil"></i>
                </vs-button>
                <vs-button circle icon flat
                           @click="$router.push({name: 'accounting.invoice.origin.freight.detail', params: {id: item.id}})"
                >
                  <i class="fad fa-eye"></i>
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :offset="offset"
                      @paginate="FetchData">
          </pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>

    <ModalDelete>
      <template v-slot="{ close }">
        <ExportExcelSplit @close="close" :invoiceId="actualSelectedItems" @success="ExportSuccess"
                          :branchType="selectedBranchType"/>
      </template>
    </ModalDelete>

    <ModalEdit>
      <template v-slot="{ close }">
        <ExportExcelTotal @close="close" :invoiceId="actualSelectedItems" @success="ExportSuccess"
                          :branchType="selectedBranchType"/>
      </template>
    </ModalEdit>

    <ModalPreviewFile>
      <template v-slot="{ close }">
        <EditStatementOrigin @close="close"
                             :invoiceId="invoice_id"
                             @success="FetchData()"
        />
      </template>
    </ModalPreviewFile>

  </div>
</template>

<script>
import mixinListInvoices from '../../Mixins/Accountings/Invoices/Invoice-Origin';
import DatePicker from "vue2-datepicker";
import Loading from '../Loading';
import ExportExcelSplit from './Dialog/Origin-Split';
import ExportExcelTotal from './Dialog/Origin-Total';
import EditStatementOrigin from './Dialog/Edit-Statement';
import {ModelListSelect} from 'vue-search-select';
import pagination from '../../Plugins/Paginations/Pagination';

export default {
  mixins: [mixinListInvoices],

  components: {
    DatePicker,
    Loading,
    ExportExcelSplit,
    ExportExcelTotal,
    ModelListSelect,
    EditStatementOrigin,
    pagination
  },

  created() {
    if (this.$can('accountingoriginfranchise')) {
      this.selectedBranchType = 'franchise'
    } else {
      this.selectedBranchType = 'branch'
    }
    this.FetchBranches();
    this.FetchData();
  }
}
</script>

<style lang="scss" scoped>
.btn-clear {
  background: $crimson;
}

.btn-export-split {
  background: $crimson;

  i {
    width: 25px;

    &:hover {
      color: $white;
    }
  }
}

.btn-export-sum {
  i {
    width: 25px;

    &:hover {
      color: $white;
    }
  }
}

</style>
